import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-between align-items-center",
  style: {"border-bottom":"0.5px solid #0000004D","padding-bottom":"0.25rem"}
}
const _hoisted_2 = { class: "position-relative d-flex gap-3 gap-md-4" }
const _hoisted_3 = {
  key: 0,
  class: "active-underline"
}
const _hoisted_4 = {
  key: 0,
  class: "position-relative"
}

import { ref, watch } from "vue";

import { Button, Input } from "@/components/global";
import { CancelIcon, SearchIcon } from "@/components/svg";

import { useDebounce } from "@/composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableHeaderControls',
  props: {
    tabs: {},
    modelValue: {},
    showSearch: { type: Boolean }
  },
  emits: ["update:modelValue", "update:search", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const query = ref<string>("");
const searchInputFocus = ref<boolean>(false);
const debouncedQuery = useDebounce(query);


watch(debouncedQuery, (val) => {
  emit("update:search", val);
  emit("change", { tab: props.modelValue, search: val });
});

const setActiveTab = (tab: string) => {
  emit("update:modelValue", tab);
  emit("change", { tab, search: query.value });
}

const clearSearch = () => {
  query.value = "";
}

const setSearchInputFocus = (value: boolean) => {
  searchInputFocus.value = value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return (_openBlock(), _createBlock(_unref(Button), {
          key: tab,
          onClick: ($event: any) => (setActiveTab(tab)),
          variant: "naked",
          class: "tab-control position-relative",
          style: _normalizeStyle({ color: __props.modelValue === tab ? 'var(--ch-black)' : '#00000080' }),
          disabled: __props.modelValue === tab
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tab) + " ", 1),
            (__props.modelValue === tab)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["onClick", "style", "disabled"]))
      }), 128))
    ]),
    (__props.showSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            style: _normalizeStyle({
          maxWidth: searchInputFocus.value || query.value ? '10rem' : '5.5rem',
          color: '#00000080',
          transition: 'all 0.3s ease-in-out'
        })
          }, [
            _createVNode(_unref(Input), {
              modelValue: query.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              type: "text",
              placeholder: "Search...",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (setSearchInputFocus(true))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (setSearchInputFocus(false))),
              variant: "naked",
              icon: _unref(SearchIcon),
              "input-class": ['py-2', searchInputFocus.value ? 'pe-4' : 'pe-0']
            }, null, 8, ["modelValue", "icon", "input-class"])
          ], 4),
          (query.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                onClick: clearSearch,
                icon: "CloseIcon",
                variant: "naked",
                class: "position-absolute end-0 top-50 translate-middle-y text-muted pe-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CancelIcon), {
                    width: "8",
                    height: "8"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})